import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import moment from 'moment';
import 'moment/locale/es';
import { UsuariosService } from '../../_services/usuarios.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component( {
  selector: 'app-recuperacion-datos',
  templateUrl: 'recuperacion-datos.component.html',
  styleUrls: [ 'ingreso.component.css' ]
} )

export class RecuperacionDatosComponent implements OnInit, OnDestroy {

  showOldPass = 'password';
  eye = 'fa-eye-slash';
  eyeNew = 'fa-eye-slash';
  newPassConfirm = '';
  newPass = '';
  showPass = 'password';
  showConfim = 'password';
  sending = false;
  token: string;
  notice = null;
  time: Date;
  minDiff: number;
  showExpire = false;
  conFondo: any;
  fondo = 1;
  fonAtributos: any = { minimo: 1, maximo: 6 };
  secMostrar = 'RECUPERAR';
  @Input() seccionActualizar: boolean;
  @Input() tokenActualizar: string;
  @Output() cargarLogin: EventEmitter<string> = new EventEmitter();
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor( private appmain: AppComponent,
               private authenticationService: AutenticacionService,
               private route: ActivatedRoute,
               private _nav: NavService,
               private router: Router,
               private usuariosService: UsuariosService ) {
  }

  ngOnInit() {
    this.cambiandoFondo();
    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'token' ] ) {
        this.token = params[ 'token' ];
      }
      if ( params[ 'time' ] ) {
        this.time = new Date( parseInt( params[ 'time' ], 10 ) );
      } else {
        this.time = new Date();
      }
      this.minDiff = moment( new Date() ).diff( this.time, 'minutes', true );
      if ( this.minDiff > 15 ) {
        this.showExpire = true;
        this.secMostrar = 'EXPIRO';
      }
    } );
    this.appmain.actualizarEstadoSesion( false );
  }


  recuperar() {
    this.notice = null;
    if ( this.newPass === this.newPassConfirm ) {
      this.sending = true;
      if ( this.seccionActualizar ) {
        /** enviar el servicio de actualizar la contrasena con el token en el header*/
        const decoded = this.jwtHelper.decodeToken( this.tokenActualizar );
        const usuIngreso = decoded.usuarios;
        usuIngreso.contrasena = this.newPass;
        usuIngreso.auditoriaUsuario = usuIngreso.idUsuario;
        this.usuariosService.actualizarContrasenia(usuIngreso, this.tokenActualizar).subscribe(res => {
          this.procesoRecuperar( res );
        });
      } else {
        this.authenticationService.cambiarContrasenaToken( this.token, this.newPass ).subscribe( res => {
          this.procesoRecuperar( res );
        }, error => {
          this.sending = false;
        } );
      }
    }
  }

  procesoRecuperar( res: any ) {
    let mensaje = '';
    let correcto = false;
    if ( res.message ) {
      switch ( res.message ) {
        case 'CONTRAIGUAL':
          mensaje = this._nav.buscarMensaje( 'USUARIOS.MSG_CONTRAIGUAL' );
          break;
        case 'ACTUALIZADA':
          mensaje = this._nav.buscarMensaje( 'AUTENTICACION.LBL_CONTRASENACAMBIADA' );
          correcto = true;
          break;
        default:
          mensaje = res.message;
          break;
      }
    }
    this._nav.setMesage( 0, {
      severity: correcto ? 'success' : 'info',
      summary: correcto ? this._nav.buscarMensaje( 'LBL_CORRECTO' ) : this._nav.buscarMensaje( 'LBL_INFORMACION' ),
      detail: mensaje
    } );
    this.notice = mensaje ? mensaje : res.message;

    /** emitir el evento para volver al login luego de actualizar la contraseña por el indicadorCambioContraseña */
    if ( correcto ) {
      /** emitir el evento que envia al login o redirigir al login, se hace porque se puede acceder de dos formas a este componente*/
      this.secMostrar = 'INGRESO';
      this.cargarLogin.emit( this.secMostrar );
      this.router.navigate( [ 'ingreso' ] );
    }
    this.sending = false;
  }

  show( type: boolean ) {
    if ( type ) {
      if ( this.showPass === 'password' ) {
        this.showPass = 'text';
        this.eye = 'fa-eye';
      } else {
        this.showPass = 'password';
        this.eye = 'fa-eye-slash';
      }
    } else {
      if ( this.showConfim === 'password' ) {
        this.showConfim = 'text';
        this.eyeNew = 'fa-eye';
      } else {
        this.showConfim = 'password';
        this.eyeNew = 'fa-eye-slash';
      }
    }


  }

  inicio() {
    if ( this.seccionActualizar ) {
      this.secMostrar = 'INGRESO';
      this.cargarLogin.emit( this.secMostrar );
    }
    this.router.navigate( [ 'ingreso' ] );
  }

  goBack() {
    if ( this.seccionActualizar ) {
      this.secMostrar = 'INGRESO';
      this.cargarLogin.emit( this.secMostrar );
    }
    this.router.navigate( [ 'ingreso' ] );
  }

  cambiandoFondo() {
    this.conFondo = setInterval( () => {
      this.fondo = Math.floor( Math.random() * (this.fonAtributos.maximo - this.fonAtributos.minimo + 1) ) + this.fonAtributos.minimo;
    }, 5000 );
  }

  ngOnDestroy() {
    clearInterval( this.conFondo );
  }

}
